import { object, string } from "yup";

import { validateCNPJ } from "@/helpers/document-helpers";
import { PASSWORD_REGEX } from "@/helpers/string-helpers";
import { IRegister } from "@/interfaces/auth.interfaces";
import { RegisterMessages } from "@/messages/register/register.messages";

import { RegisterFormData } from "./types";

export const buildformInitialData = (): RegisterFormData => {
  return {
    name: "",
    companyName: "",
    userName: "",
    document: "",
    email: "",
    phone: "55",
    password: "",
    languageCode: "PT-BR",
    fantasy: "",
  };
};

export const buildFormSchema = (messages: RegisterMessages) =>
  object().shape({
    name: string().required(messages.errorRequiredUserName),
    companyName: string().required(messages.errorRequiredCompanyName),
    email: string().email(messages.errorInvalidEmail).required(messages.errorRequiredEmail),
    phone: string().required(messages.errorRequiredPhone),
    document: string().test("cnpj", messages.invalidCNPJ, (cnpj?: string) =>
      validateCNPJ(cnpj || "")
    ),
    password: string()
      .required(messages.errorRequiredPassword)
      .matches(
        PASSWORD_REGEX,
        messages.passwordFormatError
      ),
  });

export const normalizeRegisterData = (formData: RegisterFormData): IRegister => {
  const normalizedFormData: IRegister = {
    ...formData,
    userName: formData.name,
    fantasy: formData.fantasy || formData.companyName,
  };

  return normalizedFormData;
};
